import { PAYMENT_CARD_CONST, type PaymentCardProps } from './PaymentCard.d';
import { Payment } from './PaymentCard.style';

const PaymentCard = ({ children }: PaymentCardProps) => (
  <Payment.Card data-testid={PAYMENT_CARD_CONST.TEST_ID} spacing="medium">
    {children}
  </Payment.Card>
);

export default PaymentCard;
